const SIDE_PANEL_SIZES = Object.freeze({
    NARROW: 650,
    WIDE: 1212,
    FULL: 0,
});

export default SIDE_PANEL_SIZES;
